module.exports = __webpack_public_path__ + "static/media/3.15d86558.png";